import AxiosConfig from "./AxiosConfig";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCheck, faFileImport, faQuestion, faRemove, faTimes} from "@fortawesome/free-solid-svg-icons";
import DateService from "./DateService";
import {USER_STATUS} from "./UserService";
import { ReactComponent as SablierIcone } from "../icons/asu_file_dattente.svg";

const DAYS_OF_WEEK = {
    '1': 'Lundi',
    '2': 'Mardi',
    '3': 'Mercredi',
    '4': 'Jeudi',
    '5': 'Vendredi',
    '6': 'Samedi',
    '7': 'Dimanche'
};

export const ACTIVITE_STATUS = {
    inactif: { value: 0, label: 'Contrat terminé' },
    actif: { value: 1, label: 'En cours' },
    resilie: { value: 3, label: 'Résilié' },
}

export const ACTIVITES_STATUS = [
    ACTIVITE_STATUS.inactif,
    ACTIVITE_STATUS.actif,
    ACTIVITE_STATUS.resilie,
];


export const ACTIVITE_STATUS_VALUE = [
    ACTIVITE_STATUS.inactif.value,
    ACTIVITE_STATUS.actif.value,
    ACTIVITE_STATUS.resilie.value,
];

const getActivitesStatusIcon = (status) => {
    return getContratDetailsStatusIcon(status);
}

const getActiviteStatus = (status) => {
    switch (status) {
        case ACTIVITE_STATUS.inactif.value:
            return ACTIVITE_STATUS.inactif.label;
        case ACTIVITE_STATUS.actif.value:
            return ACTIVITE_STATUS.actif.label;
        case ACTIVITE_STATUS.resilie.value:
            return ACTIVITE_STATUS.resilie.label;
        default:
            return ACTIVITE_STATUS.inactif.label;
    }
}

const saveActiviteToLocal = (newValue, userId, rateTargetId) => {
    return new Promise((resolve, reject) => {
        if (typeof newValue !== 'number' || typeof userId !== 'number' || typeof rateTargetId !== 'number' || isNaN(newValue) || isNaN(userId) || isNaN(rateTargetId)) {
            console.error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.');
            return reject(new Error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.'));
        }

        const dataToStore = {
            value: newValue,
            user: userId,
            rateTarget: rateTargetId,
        };
        const ratingsData = JSON.parse(localStorage.getItem('ratingsData')) || [];
        const existingIndex = ratingsData.findIndex(rating =>
            rating.user === userId && rating.rateTarget === rateTargetId
        );
        if (existingIndex > -1) {
            ratingsData.splice(existingIndex, 1);
        }
        ratingsData.push(dataToStore);
        localStorage.setItem('ratingsData', JSON.stringify(ratingsData));
        resolve(dataToStore);
    });
};

const getActiviteLocal = (id) => {
    return new Promise((resolve, reject) => {

        const storedData = JSON.parse(localStorage.getItem('activitesData'));
        if (storedData) {
            const foundSeance = storedData.find(s => s.id === +id);
            resolve(foundSeance);
        }
    });
};

const getActiviteApi = async (id) => {
    try {
        const response = await AxiosConfig.get(`/activites/activite/${id}`);
        return response.data.activite;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
};

const getActiviteApiWithSeances = async (id) => {
    try {
        const response = await AxiosConfig.get(`/activites/activite/${id}/seances`);
        return response.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 403) {
                console.error('Accès refusé. Vous n\'avez pas la permission d\'accéder à cette ressource.');
                return { success: false, message: 'Accès refusé. Vous n\'avez pas la permission d\'accéder à cette ressource.' };
            } else {
                console.error('Une erreur est survenue lors de la récupération des données.');
                return { success: false, message: 'Une erreur est survenue lors de la récupération des données.' };
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
            return { success: false, message: 'Le serveur ne répond pas.' };
        } else {
            console.error('Error:', error.message);
            return { success: false, message: 'Une erreur est survenue : '+error.message };
        }

        throw error;
    }
};

const getActivitesLocal = async (userId, endpoint) => {
    return new Promise((resolve, reject) => {
        const storedData = localStorage.getItem('activitesData');
        if (storedData) {
            resolve(JSON.parse(storedData));
        }
    });
};

const getActivitesApi = async (id, endpoint) => {
    try {
        const response = await AxiosConfig.get(`/activites${endpoint}`);
        return response.data.activites;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
};
const validActiviteModification = (values) => {
    let error = "";
    if (!values) {
        error += "Remplir le formulaire";
    }
    if (!values.coach) {
        error += "\n Choisir un coach";
    }
    if (!values.type) {
        error += "\n Choisir un type d'activité";
    }
    if (!values.duree_consultation) {
        error += "\n Choisir une durée de consultation";
    }
    if (!values.periode_inscription) {
        error += "\n Choisir une période d'inscription";
    }
    if (!values.pas_modifier_periodicite && !values.periodiciteCombined) {
        error += "\n Choisir une périodicité";
    }
    if (!values.pas_modifier_periodicite && !values.frequences) {
        error += "\n Choisir une fréquence";
    }

    if (!values.adresse_entreprise) {
        if (!values.adresse) {
            error += "\n Choisir une adresse";
        }
        if (!values.cp) {
            error += "\n Choisir un code postal";
        }
        if (!values.ville) {
            error += "\n Choisir une ville";
        }
    }
    if (!values.participants_max) {
        error += "\n Choisir un nombre maximum de participants";
    }
    if (!values.debut) {
        error += "\n Choisir une date de début";
    }
    if (!values.fin) {
        error += "\n Choisir une date de fin";
    }

    return { success: !error, message: error?? "Activité valide"};
};

const validActivite = (values) => {
    let error = "";
    if (!values) {
        error += "Remplir le formulaire";
    }
    if (!values.coach) {
        error += "\n Choisir un coach";
    }
    if (!values.type) {
        error += "\n Choisir un type d'activité";
    }
    if (!values.duree_consultation) {
        error += "\n Choisir une durée de consultation";
    }
    if (!values.periode_inscription) {
        error += "\n Choisir une période d'inscription";
    }
    if (!values.periodiciteCombined) {
        error += "\n Choisir une périodicité";
    }
    if (!values.frequences) {
        error += "\n Choisir une fréquence";
    }

    if (!values.adresse_entreprise) {
        if (!values.adresse) {
            error += "\n Choisir une adresse";
        }
        if (!values.cp) {
            error += "\n Choisir un code postal";
        }
        if (!values.ville) {
            error += "\n Choisir une ville";
        }
    }
    if (!values.participants_max) {
        error += "\n Choisir un nombre maximum de participants";
    }
    if (!values.debut) {
        error += "\n Choisir une date de début";
    }
    if (!values.fin) {
        error += "\n Choisir une date de fin";
    }

    return { success: !error, message: error?? "Activité valide"};
};

const fetchTypesActivite = async () => {
    const response = await AxiosConfig.get(`/activites/types`);
    return response.data;
};

const fetchTypesActiviteAdmin = async () => {
    const response = await AxiosConfig.get(`/admin/activites/types`);
    return response.data;
};

const fetchSetActiviteTypeActif = async (actType) => {
    const response = await AxiosConfig.post(`/admin/activites/types/${actType.actId}/actif`, {"actif": !actType.actActif});
    return response.data;
}

// ADMIN
const fetchToGetActivitesAdmin = async ({entrepriseId, contratId, params = null}) => {
    let url = `/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites`;
    if (params !== null) {
        url = `/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites?${params.toString()}`;
    }

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error', error);
    }
}

const fetchToSetActiviteActif = async ({activite, entrepriseId, contratId}) => {
    try {
        const response = await AxiosConfig.post(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activite.id}/actif`, {"actif": !activite.actif});
        return response.data;
    } catch (error) {
        console.error('error', error);
    }
}

const getContratDetailsStatusIcon = (status) => {
    switch (status) {
        case "0":
        case 0:
            return <FontAwesomeIcon icon={faTimes} color="orange"/>;
        case "1":
        case 1:
            return <FontAwesomeIcon icon={faCheck} color="green"/>;
        case "3":
        case 3:
            return <FontAwesomeIcon icon={faBan} color="red"/>;
        default:
            return <FontAwesomeIcon icon={faQuestion} color="grey"/>;
    }
}

const formatTime = (minutes) => {
    return DateService.addMinutesToStartOfDay(new Date(), minutes);
};

const getLabelJourSemaine = (jour_semaines) => {
    if (!jour_semaines) return "Pas de créneaux";

    return Object.keys(jour_semaines).map((jour) => {
        const horaires = jour_semaines[jour].map(formatTime).join(', ');
        return `${DAYS_OF_WEEK[jour]} ${horaires}`;
    });
};

export {
    saveActiviteToLocal,
    getActiviteLocal,
    getActiviteApi,
    getActivitesLocal,
    getActivitesApi,
    getActiviteApiWithSeances,
    validActivite,
    validActiviteModification,
    fetchTypesActivite,
    fetchSetActiviteTypeActif,
    fetchTypesActiviteAdmin,

    fetchToGetActivitesAdmin,
    fetchToSetActiviteActif,
    getContratDetailsStatusIcon,
    getLabelJourSemaine,
    getActivitesStatusIcon,
    getActiviteStatus,
};
